<template>
	<section class="properties">
		<ul class="properties__list" v-if="properties.length > 0">
			<GalleryProperty
				v-for="property of properties"
				:key="property.id"
				:property="property"
			/>
		</ul>

		<div class="properties__showmore properties-showmore" v-if="!loading && pageHasNext">
			<a class="properties-showmore__link" @click.prevent="loadMoreProperties">
				Mostra altri immobili
			</a>
		</div>
		<p v-if="loading" class="properties__loading">Caricamento...</p>
		<p v-if="error" class="properties__error">
			Errore nel caricamento:
			<br />
			{{ error }}
		</p>
	</section>
</template>

<script setup>
import {ref, onMounted, reactive} from 'vue'
import GalleryProperty from '~/default/vue/realestate/RealEstateGalleryProperty.vue'
import {getProperties} from '~/default/vue/realestate/realestate-api'

const emit = defineEmits(['propertiesUpdated'])

const {slug, contract, municipality, hamlet} = defineProps({
	slug: {
		type: String,
		required: true,
	},
	contract: {
		type: String,
		required: true,
	},
	municipality: {
		type: String,
		required: false,
	},
	hamlet: {
		type: String,
		required: false,
	},
})

const properties = reactive([])
const loading = ref(true)
const error = ref(null)
const propertiesPerPage = 30
let currentPage = 0
let pageHasNext = ref(false)

const advertiserId = WC?.PageVars?.realEstateAdvertiserId

const loadMoreProperties = () => {
	loadProperties(currentPage + 1)
}

onMounted(() => {
	loadProperties(currentPage + 1)
})

async function loadProperties(page) {
	loading.value = true

	const req = await getProperties({
		'Advertiser[0].Id': advertiserId,
		'Contracts[0].Type.Id[0]': contract,
		'Location.Municipality.Id': municipality,
		'Location.Hamlet.Id': hamlet,
		'Pagination.Page': page,
		'Pagination.PerPage': propertiesPerPage,
	})

	if (req.success) {
		// update properties
		properties.push(...req.data.properties)

		// update variables
		currentPage = req.data.pagination.page
		pageHasNext.value = req.data.pagination.hasNext
	} else {
		error.value = req.error
	}

	loading.value = false
	emit('propertiesUpdated', slug, properties.length)
}
</script>

<style lang="scss" scoped>
// Simple Asiago.it styles reset
* {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	display: block;
}
ul {
	list-style-type: none;
}
a {
	text-decoration: none;
	color: inherit;
	&:hover {
		opacity: 1;
	}
}

.properties__loading {
	padding: 3rem 0;
	text-align: center;
}

.properties__error {
	padding: 1rem 0;
	color: crimson;
}

.properties-showmore {
	display: flex;
	flex-flow: row nowrap;
	align-self: center;
	justify-content: center;
	margin: 2rem 0;
	.properties-showmore__link {
		padding: 1rem 2rem;
		text-transform: uppercase;
		font-weight: 700;
		box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
		background-color: #fff;
		transition: all 0.3s;
		border-radius: 4rem;
		cursor: pointer;
		&:hover {
			box-shadow: 0 0.4rem 0.5rem rgba(0, 0, 0, 0.35);
		}
	}
}

.properties {
	margin: 1rem 18px;
	.properties__list {
		display: flex;
		flex-flow: row wrap;
		align-items: stretch;
		justify-content: flex-start;
		margin: -0.25rem;
	}
}
</style>
